import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';

import { useCommentUpdateStore } from './CommentUpdateStore';

import useUpdateTrapActivationSignalComment from 'hooks/Traps/useUpdateTrapActivationSignalComment';

function CommentUpdateModal() {
  const { isOpen, onCommentUpdateClose, newComment, setNewComment, row, type } = useCommentUpdateStore();
  const { t } = useTranslation();
  const { updateComment, isLoading } = useUpdateTrapActivationSignalComment();
  const handleUpdate = async () => {
    try {
      await updateComment({ signalId: row?.id, comment: newComment, type: type });
      if (row?.comment) {
        enqueueSnackbar(t('MCTDetail.TrapHistoryCard.successMessageUpdate'), { variant: 'success' });
      } else {
        enqueueSnackbar(t('MCTDetail.TrapHistoryCard.successMessageAdd'), { variant: 'success' });
      }
      onCommentUpdateClose();
    } catch (error) {
      enqueueSnackbar(t('MCTDetail.TrapHistoryCard.failMessage'), { variant: 'error' });
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={() => onCommentUpdateClose()}>
      <ModalHeader toggle={() => onCommentUpdateClose()}>{t('MCTDetail.TrapHistoryCard.comment')}</ModalHeader>
      <ModalBody>
        <textarea className="form-control" value={newComment} onChange={e => setNewComment(e.target.value)} rows={3} />
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-light waves-effect waves-light" onClick={() => onCommentUpdateClose()}>
          {t('Modals.delete-modal.cancel')}
        </button>
        <button
          type="button"
          className="btn btn-purple waves-effect waves-light"
          onClick={handleUpdate}
          disabled={isLoading}
        >
          {isLoading ? (
            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
          ) : null}
          {t('MCTDetail.TrapHistoryCard.modal.Save')}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default CommentUpdateModal;
